import {Component, OnInit, Output, EventEmitter, TemplateRef, AfterViewInit} from '@angular/core';
import {MapService} from '../../core/map/map.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import 'rxjs/add/operator/startWith';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {SettingsService} from '../../core/settings/settings.service';

@Component({
  selector: 'app-places',
  templateUrl: './places.component.html',
  styleUrls: ['./places.component.scss']
})
export class PlacesComponent implements OnInit, AfterViewInit {

  @Output() close = new EventEmitter();

  searchForm: FormGroup;

  modalRef: BsModalRef;

  searchToDelete: any;

  savedSearches: any[];

  constructor(private fb: FormBuilder,
              private modalService: BsModalService,
              private settingsService: SettingsService,
              public mapService: MapService) {
  }

  ngOnInit() {
    this.searchForm = this.fb.group({
      searchString: ['', Validators.required]
    });

    this.searchForm.get('searchString').valueChanges
      .subscribe((value: string) => {
        this.mapService.setSearchString(value);
    });

    this.settingsService.get()
      .subscribe((data: any) => {
        this.savedSearches = data && data.searches || [];
        setTimeout(() => {
          this.mapService.setSearches(this.savedSearches);
        }, 4000);
      });
  }

  ngAfterViewInit() {

  }

  doSearch() {
    this.mapService.searchPlaces();
  }

  toggleSearch(search) {
    const refinedSearches = this.savedSearches.map(s => {
      if (s._id === search._id) {
        s.active = !s.active;
      }
      return s;
    });
    this.updateSearches(refinedSearches);
  }

  deleteSearch() {
    const refinedSearches = this.savedSearches.filter(s => s._id !== this.searchToDelete._id);
    this.updateSearches(refinedSearches);

    this.modalRef.hide();
    this.searchToDelete = null;
  }

  openDeleteSearchModal(template: TemplateRef<any>, search) {
    this.searchToDelete = search;
    this.modalRef = this.modalService.show(template);
  }

  saveSearch(e) {
    const searchString = this.searchForm.get('searchString').value;
    const newSearch = {active: true, value: searchString};

    this.updateSearches([...this.savedSearches, newSearch]);

    this.searchForm.get('searchString').setValue('');

    e.preventDefault();
  }

  updateSearches(searches) {
    this.settingsService.edit({searches})
      .subscribe((data: any) => {
        if (data && data.searches) {
          this.savedSearches = data.searches;
          this.mapService.setSearches(data.searches);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/places/places.component.ts